// src/components/pages/sports/Partials/Contact.jsx
import React from "react";

const Contact = ({ contactSection }) => {
  if (!contactSection) return <></>;

  return (
    <section className="pb_80 container-section">
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="sec-title text-center ">
            <h2>{contactSection.heading || "CONTACT US"}</h2>
          </div>

          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-5 col-12">
              <div className="compact-card text-center">
                <div className="name">{contactSection.name}</div>
                <div className="position">{contactSection.designation}</div>
                <div className="institution">{contactSection.institution || "Chettinad Academy of Research & Education"}</div>
                <div className="address" dangerouslySetInnerHTML={{ __html: (contactSection.address || "").replace(/\n/g, "<br/>") }} />
                {contactSection.mobile_number && <div className="contact"><span className="contact-label">Mobile:</span> {contactSection.mobile_number}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
